import Vue from 'vue'
import VueRouter from 'vue-router'
import $$ from '../assets/js/global.js'
const urlArr = []; const pathArr = []
const Margin = () =>
	import('@/views/Education/views/Margin/Margin.vue')

$.ajax({
	type: 'GET',
	url: $$.mibb + 'GetEducationContent',
	data: { id: '', lang: localStorage.getItem('lang') || 2 },
	dataType: 'json',
	async: false,
	success: (data) => {

		console.log(data);

		$.each(data.text, (i, c) => {
			if (c.title) {
				urlArr.push({
					component: Margin,
					name: 'EducationalVideos',
					path: '/msvn/Education/EducationalVideos',
					meta: {
						// 判断是否有三级导航栏
						ViewsNav: false,
						id: c.id,
						name: 'Educational Videos',
						title: 'Educational Videos -  Education | Maybank Covered Warrants',
						// img: require(`../../public/image/EducationIndex_${i + 3}.jpg`),
						img: c.image ? c.image : 'https://warrants.maybank2u.com.my/mibbresources/assets/Education 1.jpg',
						content: {}
					}
				})
			}
		})
	},
	error: function (error) {
		console.log(error)
	}
})
console.log(urlArr);
// LandingPage
const Home = () =>
	import('../views/Home/Home.vue')

// Warrant tools
const WarrantTools = () =>
	import('@/views/WarrantTools/WarrantTools.vue')
// Views
const LiveMatrix = () =>
	import('@/views/WarrantTools/views/LiveMatrix/LiveMatrix.vue')
const WarrantSearch = () =>
	import('@/views/WarrantTools/views/WarrantSearch/WarrantSearch.vue')
const WarrantTerms = () =>
	import('@/views/WarrantTools/views/WarrantTerms/WarrantTerms.vue')
const WarrantComparison = () =>
	import('@/views/WarrantTools/views/WarrantComparison/WarrantComparison.vue')
const WarrantCalculator = () =>
	import('@/views/WarrantTools/views/WarrantCalculator/WarrantCalculator.vue')
const StructureYourWarrant = () =>
	import('@/views/WarrantTools/views/StructureYourWarrant/StructureYourWarrant.vue')
const Underlying = () =>
	import('@/views/WarrantTools/views/Underlying/Underlying.vue')

// Observations
const Observations = () =>
	import('@/views/Observations/Observations.vue')
// Views
const TopTradedShares = () =>
	import('@/views/Observations/views/TopTradedShares/TopTradedShares.vue')
const WarrantMovers = () =>
	import('@/views/Observations/views/WarrantMovers/WarrantMovers.vue')
const DailyHighlights = () =>
	import('@/views/Observations/views/DailyHighlights/DailyHighlights.vue')
const WarrantWatch = () =>
	import('@/views/Observations/views/WarrantWatch/WarrantWatch.vue')
const WarrantsBulletin = () =>
	import('@/views/Observations/views/WarrantsBulletin/WarrantsBulletin.vue')
const ExpiredWarrant = () =>
	import('@/views/Observations/views/ExpiredWarrant/ExpiredWarrant.vue')

// Warrants Documentations
const Documents = () =>
	import('@/views/Documents/Documents.vue')
// Views
const BaseProspectus = () =>
	import('@/views/Documents/views/BaseProspectus/BaseProspectus.vue')
const TermSheet = () =>
	import('@/views/Documents/views/TermSheet/TermSheet.vue')
const WarrantsAnnouncement = () =>
	import('@/views/Documents/views/WarrantsAnnouncement/WarrantsAnnouncement.vue')
const UnderlyingReports = () =>
	import('@/views/Documents/views/UnderlyingReports/UnderlyingReports.vue')
const PurchaseOrderForm = () =>
	import('@/views/Documents/views/PurchaseOrderForm/PurchaseOrderForm.vue')

// Education
const Education = () =>
	import('@/views/Education/Education.vue')
const EducationIndex = () =>
	import('@/views/Education/views/Index/index.vue')
// Views
const Glossary = () =>
	import('@/views/Education/views/Glossary/Glossary.vue')
const DecksAndSlides = () =>
	import('@/views/Education/views/DecksAndSlides/DecksAndSlides.vue')

const Indonesia = () =>
	import('@/views/Education/views/Indonesia/Indonesia.vue')
const WatchOurSeminars = () =>
	import('@/views/Education/views/WatchOurSeminars/WatchOurSeminars.vue')

// About Maybank Investment Bank
const AboutUs = () =>
	import('@/views/AboutUs/AboutUs.vue')
// Views
const SonAboutUs = () =>
	import('@/views/AboutUs/views/SonAboutUs/SonAboutUs.vue')
const ContactUs = () =>
	import('@/views/AboutUs/views/ContactUs/ContactUs.vue')
const Disclaimer = () =>
	import('@/views/AboutUs/views/Disclaimer/Disclaimer.vue')

Vue.use(VueRouter)

const routes = [
	// 路由重定向
	{
		path: '/',
		redirect: '/msvn/Home',
		hidden: true,
		meta: {
			title: localStorage.getItem('lang') <= 1 ? 'Home | Maybank Covered Warrants Limited' : 'Home | Maybank Covered Warrants Limited',
			content: {
				keywords: '',
				description: ''
			}
		}
	},
	// LandingPage
	{
		path: '/msvn/Home',
		name: 'Home',
		component: Home,
		meta: {
			name: 'nav.H',
			title: localStorage.getItem('lang') <= 1 ? 'Home | Maybank Covered Warrants Limited' : 'Home | Maybank Covered Warrants Limited',
			content: {
				keywords: '',
				description: ''
			}
		}
	},

	// Warrant tools
	{
		path: '/msvn/WarrantTools',
		name: 'Warrant tools',
		component: WarrantTools,
		meta: {
			name: 'nav.WT'
		},
		// Views
		children: [
			{
				path: '/msvn/WarrantTools/LiveMatrix',
				name: 'Live Matrix',
				component: LiveMatrix,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.LM',
					title: localStorage.getItem('lang') <= 1 ? 'Live Matrix - Warrant Tools | Maybank Covered Warrants' : 'Ma trận trực tiếp - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Live Matrix, Bid Price,',
						description: 'Review the indicative bid and offer prices for warrants listed by Maybank IB, based on various price points in the underlying (stock or index).'
					}
				}
			},
			{
				path: '/msvn/WarrantTools/WarrantSearch',
				name: 'Warrant Search',
				component: WarrantSearch,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.WS',
					title: localStorage.getItem('lang') <= 1 ? 'Warrant Search - Warrant Tools | Maybank Covered Warrants' : 'Tìm kiếm chứng quyền - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Pencarian Waran, Tren Waran, Waran Baru, Waran Sensitif, Likuiditas Tinggi',
						description: 'Cari waran pilihan Anda dengan mudah'
					}
				}
			}, {
				path: '/msvn/WarrantTools/WarrantTerms',
				name: 'Warrant Terms',
				component: WarrantTerms,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.WTe',
					title: localStorage.getItem('lang') <= 1 ? 'Warrant Terms - Warrant Tools | Maybank Covered Warrants' : 'Thông tin chứng quyền - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Persyaratan Waran, Ketentuan Waran, Grafik Waran',
						description: 'Bandingkan Ketentuan Waran dari beberapa waran secara bersamaan dengan menggunakan indikator utamanya untuk setiap waran yang tercatat di Bursa Efek Indonesia (BEI).'
					}
				}
			}, {
				path: '/msvn/WarrantTools/WarrantComparison',
				name: 'Warrant Comparison',
				component: WarrantComparison,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.WC',
					title: localStorage.getItem('lang') <= 1 ? 'Warrant Comparison - Warrant Tools | Maybank Covered Warrants' : 'So sánh Chứng quyền - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Perbandingan Waran',
						description: 'Bandingkan waran dan underlying nya dengan menggunakan faktor kunci yang telah disediakan berdampingan'
					}
				}
			}, {
				path: '/msvn/WarrantTools/WarrantCalculator',
				name: 'Warrant Calculator',
				component: WarrantCalculator,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.WCa',
					title: localStorage.getItem('lang') <= 1 ? 'Warrant Calculator - Warrant Tools | Maybank Covered Warrants' : 'Tính toán Chứng quyền - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Kalkulator Waran, Penyelesaian Waran, Harga Waran',
						description: 'Kalkulator waran memudahkan investor untuk mengukur harga teoritis dari suatu waran yang diminatinya'
					}
				}
			}, {
				path: '/msvn/WarrantTools/StructureYourWarrant',
				name: 'Structure Your Warrant',
				component: StructureYourWarrant,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.SYW',
					title: localStorage.getItem('lang') <= 1 ? 'Structure Your Warrant - Warrant Tools | Maybank Covered Warrants' : 'Cấu trúc Chứng quyền của bạn - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Saran Waran, Rekomendasi Waran, Maybank Sekuritas Menerbitkan Waran, Menyusun Waran Anda',
						description: 'Mekanisme umpan balik memberikan solusi dan saran terkait waran yang diminati investor'
					}
				}
			},
			{
				path: '/msvn/WarrantTools/TechnicalChart',
				name: 'Technical Chart',
				component: Underlying,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.TC',
					title: localStorage.getItem('lang') <= 1 ? 'Technical Chart - Warrant Tools | Maybank Covered Warrants' : 'Biểu đồ kỹ thuật - CÔNG CỤ CHỨNG QUYỀN | Maybank Covered Warrants',
					content: {
						keywords: 'Grafik Teknis, Analisis Teknis',
						description: 'Lakukan analisis teknikal pada grafik underlying untuk menganalisis arah dan performa dari suatu underlying waran'
					}
				}
			}
		]
	},
	// Observations
	{
		path: '/msvn/Observations',
		name: 'Observations',
		component: Observations,
		meta: {
			name: 'nav.Ob'
		},
		// Views
		children: [
			{
				path: '/msvn/Observations/TopTradedShares',
				name: 'Top Traded Shares',
				component: TopTradedShares,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.TTS',
					title: localStorage.getItem('lang') <= 1 ? 'Top Traded Shares - Observations | Maybank Covered Warrants' : 'Cổ phiếu được giao dịch hàng đầu - QUAN SÁT | Maybank Covered Warrants',
					content: {
						keywords: 'Saham yang diperdagangkan teratas',
						description: 'Peringkat 10 terbaik berdasarkan volume transaksi, terkait dengan underlying saham dari Waran Terstruktur yang diterbitkan oleh Maybank Sekuritas '
					}
				}
			},
			{
				path: '/msvn/Observations/WarrantMovers',
				name: 'Warrant Movers',
				component: WarrantMovers,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.WM',
					title: localStorage.getItem('lang') <= 1 ? 'Warrant Movers - Observations | Maybank Covered Warrants' : 'Chuyển động Chứng quyền - QUAN SÁT | Maybank Covered Warrants',
					content: {
						keywords: 'Top 10 ranking of Indonesian warrants by category.',
						description: 'Peringkat 10 besar waran Indonesia berdasarkan kategori'
					}
				}
			},
			// {
			// 	path: '/Observations/WarrantsWatch',
			// 	name: 'Warrants Watch',
			// 	component: WarrantWatch,
			// 	meta: {
			// 		// 判断是否有三级导航栏
			// 		ViewsNav: false,
			// 		name: 'nav.WW',
			// 		titleEn: 'Warrants Watch - Observations | Maybank Covered Warrants',
			// 		titleId: 'Pengamat Waran – Pengamatan | Maybank Covered Warrants',
			// 		content: {
			// 			keywords: 'Warrant Information, Daily Highlights, Warrant News, Sector Warrants Write Up, Warrant Suggestion, Warrant Recommendation,',
			// 			description: 'Maybank Insights on selected warrants.'
			// 		}
			// 	}
			// },
			// {
			// 	path: 'https://telegram.org/',
			// 	name: 'Telegram Live',
			// 	meta: {
			// 		// 判断是否有三级导航栏
			// 		ViewsNav: false,
			// 		title: 'Telegram Live - Observations | Maybank Covered Warrants',
			// 		content: {}
			// 	}
			// },
			{
				path: '/msvn/Observations/WarrantsBulletin',
				name: 'Warrants Bulletin',
				component: WarrantsBulletin,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.WB',
					title: localStorage.getItem('lang') <= 1 ? 'Warrants Bulletin - Observations | Maybank Covered Warrants' : 'Bản tin Chứng quyền - QUAN SÁT | Maybank Covered Warrants',
					content: {
						keywords: 'Berita dan Update Waran Terstruktur',
						description: 'Informasi singkat tentang update waran, waran baru dan jatuh tempo, serta waran apa saja yang harus diinvestasikan'
					}
				}
			},
			{
				path: '/msvn/Observations/ExpiredWarrant',
				name: 'Expired Warrant',
				component: ExpiredWarrant,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'hp.EW',
					title: localStorage.getItem('lang') <= 1 ? 'Expiring Warrant - Observations | Maybank Covered Warrants' : 'Chứng quyền sắp đáo hạn - QUAN SÁT | Maybank Covered Warrants',
					content: {
						keywords: 'Ketahui waran berstruktur oleh Maybank yang bakal berakhir',
						description: 'Ketahui waran berstruktur oleh Maybank yang bakal berakhir'
					}
				}
			}
		]
	},
	// Warrants Documentations
	{
		path: '/msvn/Documents',
		name: 'Documents',
		component: Documents,
		meta: {
			name: 'nav.Do'
		},
		// Views
		children: [{
			path: '/msvn/Documents/BaseProspectus',
			name: 'Base Prospectus',
			component: BaseProspectus,
			meta: {
				// 判断是否有三级导航栏
				ViewsNav: false,
				name: 'nav.BP',
				title: localStorage.getItem('lang') <= 1 ? 'Base Prospectus - Documents | Maybank Covered Warrants' : 'Bản cáo bạch - CÁC TÀI LIỆU | Maybank Covered Warrants',
				content: {
					keywords: 'Prospektus Waran Maybank Sekuritas',
					description: 'Disarankan agar Anda meninjau dokumen-dokumen ini sebelum berinvestasi dalam waran terstruktur'
				}
			}
		},
		// {
		// 	path: '/msvn/Documents/TermSheet',
		// 	name: 'Term Sheet',
		// 	component: TermSheet,
		// 	meta: {
		// 		// 判断是否有三级导航栏
		// 		ViewsNav: false,
		// 		name: 'nav.TS',
		// 		title: 'Lembar Ketentuan - Lampiran | Maybank Sekuritas Warrants',
		// 		content: {
		// 			keywords: 'Lembar Ketentuan Waran Maybank Sekuritas, Dokumen Waran Maybank Sekuritas',
		// 			description: 'Disarankan agar Anda meninjau dokumen-dokumen ini sebelum berinvestasi dalam waran terstruktur'
		// 		}
		// 	}
		// },
		{
			path: '/msvn/Documents/WarrantsAnnouncement',
			name: 'Warrants Announcement',
			component: WarrantsAnnouncement,
			meta: {
				name: 'nav.WA',
				title: localStorage.getItem('lang') <= 1 ? 'Warrants Announcement - Documents | Maybank Covered Warrants' : 'Thông báo Chứng quyền - CÁC TÀI LIỆU | Maybank Covered Warrants',
				content: {
					keywords: 'Pengumuman Waran',
					description: 'Pengumuman terkait penerbitan waran Maybank Sekuritas termasuk penyesuaian aksi korporasi'
				}
			}
		},

			// {
			//   path: '/Documents/UnderlyingReports',
			//   name: 'Underlying Reports',
			//   component: UnderlyingReports,
			//   meta: {
			//     // 判断是否有三级导航栏
			//     ViewsNav: false,
			//     title: '',
			//     content: {}
			//   }
			// }
			// {
			// 	path: '/msvn/Documents/PurchaseOrderForm',
			// 	name: 'Purchase Order Form',
			// 	component: PurchaseOrderForm,
			// 	meta: {
			// 		name: 'nav.SWs',
			// 		title: localStorage.getItem('lang') <= 1 ? 'Purchase Order Form - Documents | Maybank Covered Warrants' : 'Mẫu đặt mua - CÁC TÀI LIỆU | Maybank Covered Warrants',
			// 		content: {
			// 			keywords: 'Penawaran Umum Perdana, Penawaran Umum',
			// 			description: 'Jadilah yang pertama membeli waran yang diterbitkan Maybank Sekuritas selama periode penawaran umum'
			// 		}
			// 	}
			// }

		]
	},
	// Education
	{
		path: '/msvn/Education',
		name: 'Education',
		component: Education,
		meta: {
			name: 'nav.Ed'
		},
		// Views
		children: [
			{
				path: '/msvn/Education/Education',
				name: 'EducationIndex',
				component: EducationIndex,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					title: 'Education | Maybank Covered Warrants',
					content: {
						keywords: 'Video Waran, Infografis Waran',
						description: 'Tingkatkan pengetahuan waran terstruktur senyaman Anda berada dirumah'
					}
				}
			},
			// Indicators
			{
				path: '/msvn/Education/Glossary',
				name: 'Glossary',
				component: Glossary,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.Gl',
					title: localStorage.getItem('lang') <= 1 ? 'Glossary - Education | Maybank Covered Warrants' : 'Chú giải - GIÁO DỤC | Maybank Sekuritas Warrants',
					img: require('../../public/image/EducationIndex_2.png'),
					description: 'Gly.Sitywt',
					content: {
						keywords: 'Terminologi Waran, Istilah Waran',
						description: 'Kumpulan terminologi investasi yang mungkin Anda temui dalam perdagangan waran'
					}
				}
			},
			{
				path: '/msvn/Education/DecksAndSlides',
				name: 'Decks and Slides',
				component: DecksAndSlides,
				meta: {
					// 判断是否有三级导航栏
					ViewsNav: false,
					name: 'nav.DaS',
					title: localStorage.getItem('lang') <= 1 ? 'Decks and Slides - Education | Maybank Covered Warrants' : 'Tài liệu liên quan - GIÁO DỤC | Maybank Covered Warrants',
					img: require('../../public/image/EducationIndex_3.png'),
					description: 'DASs.DweWW',
					content: {
						keywords: 'Maybank Webinar Decks, Maybank Webinar Presentation',
						description: 'Download decks from webinars or information relating to Warrants Trading and the Maybank Covered Warrants Website'
					}
				}
			},
			{
				path: '/msvn/Documents/Infographics',
				name: 'Infographics',
				component: Indonesia,
				meta: {
					name: 'nav.Ia',
					title: '',
					img: require('../../public/image/Infographics_img.jpg'),
					description: 'SWS.TitleI',
					content: {
						keywords: '',
						description: ''
					}
				}
			},
			...urlArr

			// {
			// 	path: '/Education/WatchOurSeminars',
			// 	name: 'Watch Our Seminars',
			// 	component: WatchOurSeminars,
			// 	meta: {
			// 		// 判断是否有三级导航栏
			// 		ViewsNav: false,
			// 		title: '',
			// 		content: {}
			// 	}
			// }
		]
	},
	// About Maybank Investment Bank
	{
		path: '/msvn/AboutUs',
		name: 'About Us',
		component: AboutUs,
		meta: {
			name: 'nav.AU'
		},
		// Views
		children: [{
			path: '',
			name: 'About Us',
			component: SonAboutUs,
			meta: {
				name: 'nav.AU',
				path: localStorage.getItem('lang') <= 1 ? 'https://www.maybank-kimeng.com.vn/securities/about-us/milestone/en' : 'https://www.maybank-kimeng.com.vn/securities/about-us/milestone/vi',
				title: localStorage.getItem('lang') <= 1 ? 'About Us - ABOUT US | Maybank Covered Warrants' : 'VỀ CHÚNG TÔI - Về chúng tôi | Maybank Covered Warrants',
				content: {
					keywords: 'Waran Terstruktur Maybank Sekuritas',
					description: 'Sejarah dan Latar belakang Maybank Sekuritas'
				}
			}
		}, {
			path: '/msvn/AboutUs/ContactUs',
			name: 'Contact Us',
			component: ContactUs,
			meta: {
				name: 'nav.CU',
				title: localStorage.getItem('lang') <= 1 ? 'Contact Us - ABOUT US | Maybank Covered Warrants' : 'Liên hệ - Về chúng tôi | Maybank Covered Warrants',
				content: {
					keywords: 'Help Desk Waran Maybank Sekuritas, Waran Terstruktur Maybank Sekuritas',
					description: 'Hubungi tim Waran Maybank Sekuritas'
				}
			}
		}, {
			path: '/msvn/AboutUs/Disclaimer',
			name: 'Disclaimer',
			component: Disclaimer,
			meta: {
				name: 'nav.Di',
				title: localStorage.getItem('lang') <= 1 ? 'Disclaimer - ABOUT US | Maybank Covered Warrants' : 'Miễn trừ trách nhiệm - Về chúng tôi | Maybank Covered Warrants',
				content: {
					keywords: '',
					description: 'Syarat dan Ketentuan yang berlaku saat menggunakan Website Waran Maybank Sekuritas'
				}
			}
		}

		]
	}
]

// 解决重复触发了同一个路由
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
